import { render, staticRenderFns } from "./InfoChatWazzupSection.vue?vue&type=template&id=12bede3f&scoped=true&"
import script from "./InfoChatWazzupSection.vue?vue&type=script&lang=js&"
export * from "./InfoChatWazzupSection.vue?vue&type=script&lang=js&"
import style0 from "./InfoChatWazzupSection.vue?vue&type=style&index=0&id=12bede3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bede3f",
  null
  
)

export default component.exports